module.exports = __webpack_public_path__ + "img/jgdt.e840ac77.svg";